import { render, staticRenderFns } from "./QuestionDate.vue?vue&type=template&id=7b0a8b0e&scoped=true&"
import script from "./QuestionDate.vue?vue&type=script&lang=js&"
export * from "./QuestionDate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDate.vue?vue&type=style&index=0&id=7b0a8b0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0a8b0e",
  null
  
)

export default component.exports